import * as React from "react";

import { PageInternal } from "@pro/containers/PageInternal";

import { Routing } from "@common/_constants";
import { Button } from "@common/components/Atoms/Button";

export class ErrorNotFound extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit() {
        window.location.href = "/pro" + Routing.Client.Pro.Home.DASHBOARD;
    }

    render() {
        return (
            <PageInternal className="c-page--404">
                <div className="c-block">
                    <h1>oops, looks like something went wrong</h1>
                    <p>We can't seem to find the page you're looking for.</p>
                    <Button id="back-to-home-button" green={true} onClick={this.handleSubmit}>
                        back to home
                    </Button>
                </div>
            </PageInternal>
        );
    }
}
